import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import actionCreators from "../../store/actions/auth";

const Login = () => {
  const dispatch = useDispatch();
  const authenticated = useSelector(state => state.auth.authenticated);

  useEffect(() => {
    if (!authenticated) {
      dispatch(actionCreators.signinUser());
    }
  }, [authenticated, dispatch]);

  if (authenticated) {
    return <Navigate to="/" replace />
  }

  return null;
};

export default Login;

